import React from "react";
import { Helmet } from "react-helmet-async";
import { Box, Container } from "@mui/material";
import { useParams } from "react-router-dom";
import MarketingNav from "../components/MarketingNav";
import FanPageScreen from "../components/fanPage/FanPageScreen";
import { useGetFanPageByHandleQuery } from "../store/api/mlbApi";

const PublicFanPage = () => {
  const { handle } = useParams();
  const { data: page, isLoading, error } = useGetFanPageByHandleQuery(handle, {
    skip: !handle,
  });

  const titleHandle = page?.handle || handle;

  return (
    <>
      <Helmet>
        <title>
          {titleHandle
            ? `@${titleHandle}’s all-time lineup — Stats.Fan`
            : "All-time lineup — Stats.Fan"}
        </title>
        <meta
          name="description"
          content={`All-time starting nine and favorites from @${titleHandle} on Stats.Fan.`}
        />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <MarketingNav />
      <Box sx={{ pt: { xs: 10, md: 12 }, pb: 8, minHeight: "100vh" }}>
        <Container maxWidth="lg">
          <FanPageScreen page={page} loading={isLoading} error={error} />
        </Container>
      </Box>
    </>
  );
};

export default PublicFanPage;
